import React from "react";
import "./Invitation_Reward_Rules.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import Rules_card from "../Common/Common_Component/Rules_card/Rules_card";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";

function Invitation_Reward_Rules() {
  const navigate = useNavigate();
  const tableData = [
    1,
    3,
    10,
    30,
    50,
    70,
    100,
    200,
    500,
    1000,
    5000,
    10000,
    50000,
    100000,
    200000,
    500000,
  ];

  return (
    <section className="Invitation_Reward_Rules">
      <Common_white_header headingText={"Invitation Reward Rules"} />

      <div className="container">
        {/* Top Description */}
        <div className="text_holder">
          <p>
            Invite friends and recharge to get additional platform rewards!
            After being claimed, the rewards will be directly distributed to the
            wallet balance within 10 minutes.
          </p>
        </div>

        {/* Table Section */}
        <div className="table_wrapper">
          <table className="reward_table">
            <thead>
              <tr>
                <th>Invite account</th>
                <th>Deposit Amount</th>
                <th>Bonus</th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((item, index) => (
                <tr key={index}>
                  <td>{item} People</td>
                  <td>₹ 600.00</td>
                  <td>₹ 55.00</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Rules Section */}
        <Rules_card />
        <Rules_card />

        <div className="">
          <Button
            className="btn-register  mb-3"
            onClick={() => navigate("/invitation-rules")}
          >
            View All Roules
          </Button>
        </div>
      </div>
    </section>
  );
}

export default Invitation_Reward_Rules;
